import React, { useState, useEffect } from 'react';

const PrivacyNoticeBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissedAt = localStorage.getItem('privacy_notice_dismissed_at');
    const now = new Date().getTime();

    if (!dismissedAt || now - parseInt(dismissedAt) > 24 * 60 * 60 * 1000) {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('privacy_notice_dismissed_at', new Date().getTime().toString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={styles.banner}>
      <p style={styles.text}>
        🔒 At Litmus Services, we respect your privacy. We collect and process data responsibly to protect your dignity and confidentiality.{' '}
        <a href="/privacy-policy" style={styles.link}>Learn more</a>
      </p>
      <button onClick={handleDismiss} style={styles.button}>
        ×
      </button>
    </div>
  );
};

const styles = {
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#e0f7f4',
    color: '#004d40',
    padding: '1rem',
    fontSize: '0.95rem',
    borderBottom: '2px solid #b2dfdb',
    position: 'relative',
    zIndex: 1000,
  },
  text: {
    margin: 0,
    flex: 1,
    paddingRight: '1rem',
  },
  link: {
    color: '#00796b',
    textDecoration: 'underline',
  },
  button: {
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    color: '#00796b',
    cursor: 'pointer',
    lineHeight: '1',
  },
};

export default PrivacyNoticeBanner;
